<template>
    <div>
       
    </div>
</template>

<script>

export default {
    components:{
    },
     data() {
        return {
           
        }
     },
    methods: {
       
    },
    created() {

    },
    mounted() {

    }
}
</script>
<style lang="css" scoped>

</style>